import currentWidgetDetails from "utilities/platform/widget-details";




export const spartaContainerSelector = '[data-sparta-wrapper]';





export const spartaWidgetContainerString = 'data-sparta-widget';





export const spartaWidgetContainerSelector = `[${spartaWidgetContainerString}]`;





export const utilityLoadingClass = 'sparta-media-query-utility-loading';





export const spartaWidgetResizeDebounceDelay = 200;





export const mediaQueryViewportString = 'viewport';





export const mediaQueryOrientationString = 'orientation';





export const mediaQueryResolutionString = 'resolution';





export const mediaQueryUpString = 'up';





export const mediaQueryOnlyString = 'only';





export const spartaStoreNamespace = 'currentMQ';





export const spartaStoreMediaQueriesKey = 'mediaQueries';





export const xsmallMinWidth = 1;





export const smallMinWidth = 1;





export const smallMidMinWidth = 375;





export const smallPlusMinWidth = 414;





export const mediumMinWidth = 768;





export const largeMinWidth = 1025;






export const largeCenteredMinWidth = 1296;





export const xlargeMinWidth = 1296;





export const xxlargeMinWidth = 1440;





export const xsmallViewportName = 'xsmall';





export const xsmallViewportString = xsmallViewportName;





export const smallViewportName = 'small';





export const smallViewportString = smallViewportName;





export const smallMidViewportName = 'smallMid';





export const smallMidViewportString = smallMidViewportName;





export const smallPlusViewportName = 'smallPlus';





export const smallPlusViewportString = smallPlusViewportName;





export const smallPlusViewportName2 = 'small-plus';





export const smallPlusViewportString2 = smallPlusViewportName2;





export const mediumViewportName = 'medium';





export const mediumViewportString = mediumViewportName;





export const largeViewportName = 'large';





export const largeViewportString = largeViewportName;





export const xlargeViewportName = 'xlarge';





export const xlargeViewportString = xlargeViewportName;





export const xxlargeViewportName = 'xxlarge';





export const xxlargeViewportString = xxlargeViewportName;






export const largeCenteredViewportName = 'largeCentered';





export const landscapeOrientationName = 'landscape';





export const portraitOrientationName = 'portrait';





export const defaultResolutionName = 'standard';





export const retinaResolutionName = 'retina';





export const xsmallMediaQueryString = `all and (min-width: ${xsmallMinWidth}px)`;





export const smallMediaQueryString = `all and (min-width: ${smallMinWidth}px)`;





export const smallMidMediaQueryString = `all and (min-width: ${smallMidMinWidth}px)`;





export const smallPlusMediaQueryString = `all and (min-width: ${smallPlusMinWidth}px)`;





export const mediumMediaQueryString = `all and (min-width: ${mediumMinWidth}px)`;





export const largeMediaQueryString = `all and (min-width: ${largeMinWidth}px)`;






export const largeCenteredMediaQueryString = `all and (min-width: ${largeCenteredMinWidth}px)`;





export const xlargeMediaQueryString = `all and (min-width: ${xlargeMinWidth}px)`;





export const xxlargeMediaQueryString = `all and (min-width: ${xxlargeMinWidth}px)`;





export const portraitMediaQueryString = `all and (orientation: ${portraitOrientationName})`;





export const landscapeMediaQueryString = `all and (orientation: ${landscapeOrientationName})`;





export const defaultResolutionMediaQueryString = `not screen and (min-device-pixel-ratio: 2), not screen and (min-resolution: 192dpi), not screen and (min-resolution: 2dppx)`;





export const retinaResolutionMediaQueryString = `all and (min-device-pixel-ratio: 2), all and (min-resolution: 192dpi), all and (min-resolution: 2dppx)`;





export const viewportNames = {
  [xsmallViewportName]: xsmallViewportString,
  [smallViewportName]: smallViewportString,
  [smallMidViewportName]: smallMidViewportString,
  [smallPlusViewportName]: smallPlusViewportString,
  [smallPlusViewportName2]: smallPlusViewportString2,
  [mediumViewportName]: mediumViewportString,
  [largeViewportName]: largeViewportString,
  [largeCenteredViewportName]: largeCenteredViewportName,
  [xlargeViewportName]: xlargeViewportString,
  [xxlargeViewportName]: xxlargeViewportString,
};
